const proposalRequestsConstantsEN = {
  proposalRequestsPageTitle: 'Proposal Requests',
  proposalRequestsBreadcrumbs: 'PROPOSAL REQUESTS',
  proposalRequestsTableTitleRequestsId: 'Quote Requests ID',
  proposalRequestsTableTitleDate: 'Date',
  proposalRequestsTableTitleUsername: 'User Name',
  proposalRequestsTableTitleCompanyName: 'Company Name',
  proposalRequestsTableTitleStatus: 'Status',
  totalProposalRequestItems: 'Proposal requests',

  newQuoteStatus: 'New Quote Request',
  pendingQuoteStatus: 'Pending Quote',
  acceptedQuoteStatus: 'Accepted',
  rejectedQuoteStatus: 'Canceled',
};

export default proposalRequestsConstantsEN;
